// Settings → Domains: the client's own domains (kept by Digimasi's console), the mail domain, and requests to our team.
export const domainsEn = {
  'layout.nav.domains': 'Domains',
  'dom.title': 'Domains',
  'dom.subtitle': 'Put your website on your own domain, such as yourcompany.com. You keep the domain where you bought it; you only change two settings there, and we do the rest.',
  'dom.count': 'Domains: {used} of {limit}',
  'dom.countHint': 'Your package includes {limit}. Your main address is where your website lives; other domains lead visitors to it.',
  'dom.upgrade.title': 'Use your own domain',
  'dom.upgrade.body': 'Your own domain (yourcompany.com instead of a digimasi.com address) comes with the Business package and up. Upgrade and we set it up with you.',
  'dom.empty.title': 'No own domain yet',
  'dom.empty.body': 'Your website is on its digimasi.com address. Add your domain below to start.',
  'dom.add.title': 'Add a domain',
  'dom.add.field': 'Your domain',
  'dom.add.hint': 'Just the domain, such as yourcompany.com: no www, no https.',
  'dom.add.placeholder': 'yourcompany.com',
  'dom.add.submit': 'Add domain',
  'dom.add.submitting': 'Adding…',
  'dom.added': 'Domain added. Now change its nameservers (see the steps below).',
  'dom.atLimit': 'Your package allows {limit} domains, and you have them all. Remove an extra domain, or upgrade your package.',
  'dom.notConnected': 'Adding a domain is not available right now. Contact us and we add it for you.',
  'dom.upgradeCta': 'Upgrade / contact us',
  'dom.chip.primary': 'Main address',
  'dom.chip.mail': 'Mail domain',
  'dom.state.waiting': 'Waiting for nameservers',
  'dom.state.connecting': 'Connecting',
  'dom.state.active': 'Active',
  'dom.state.problem': 'Needs attention',
  'dom.added.on': 'Added {date}',
  'dom.ns.title': 'Your two nameservers',
  'dom.ns.label': 'Nameserver {n}',
  'dom.steps.title': 'What to do',
  'dom.steps.1': 'Sign in where you bought the domain (your registrar).',
  'dom.steps.2': 'Find “Nameservers” or “DNS”, and choose custom nameservers.',
  'dom.steps.3': 'Replace the current ones with the two above, and save.',
  'dom.steps.4': 'Wait: it usually takes a few hours, sometimes up to 48 hours. We check automatically.',
  'dom.check': 'Check now',
  'dom.checking': 'Checking…',
  'dom.checked.waiting': 'Not yet: the nameservers have not changed. We keep checking.',
  'dom.checked.ready': 'The nameservers are set. Our team connects your domain next.',
  'dom.connecting.body': 'Your domain is ready. Our team connects it to your website, usually within one working day. You don’t need to do anything.',
  'dom.active.body': 'Your website answers on this domain.',
  'dom.problem.body': 'Something needs a look. Our team has been told.',
  'dom.primary.note': 'Only Digimasi changes the main address.',
  'dom.mail.note': 'Mail for addresses on this domain arrives in your Inbox. To change it, send a request below.',
  'dom.mail.locked': 'Locked',
  'dom.remove': 'Remove',
  'dom.remove.title': 'Remove {domain}?',
  'dom.remove.body': 'Your website stops answering on {domain}. If it was waiting for nameservers, the setup is cancelled. This does not touch your main address or your mail.',
  'dom.remove.confirm': 'Remove domain',
  'dom.removed': 'Domain removed.',
  'dom.help.title': 'Need help? We’ll connect it for you',
  'dom.help.body': 'Not sure where to change the nameservers? Tell us, and our team helps you or does it with you.',
  'dom.help.open': 'Ask for help',
  'dom.help.domain': 'Which domain? (optional)',
  'dom.help.note': 'Anything we should know? (optional)',
  'dom.help.notePlaceholder': 'For example: where you bought the domain, or the best time to call you.',
  'dom.help.submit': 'Send request',
  'dom.help.sent': 'Request sent. Our team will contact you.',
  'dom.help.pending': 'Your request for help is with our team. We will contact you.',
  'dom.mailChange.title': 'Request a mail-domain change',
  'dom.mailChange.body': 'Your mail domain is {domain}. Our team can move your mailbox to another of your domains.',
  'dom.mailChange.open': 'Request a change',
  'dom.mailChange.domain': 'New mail domain (optional)',
  'dom.mailChange.domainOther': 'Another domain',
  'dom.mailChange.domainFree': 'The domain you want',
  'dom.mailChange.note': 'Why, or what should change',
  'dom.mailChange.warning': 'Addresses on the old domain will stop receiving mail and lose access. Their mail history will be deleted. This cannot be undone.',
  'dom.mailChange.ack': 'I understand',
  'dom.mailChange.submit': 'Send request',
  'dom.mailChange.sent': 'Request sent. Our team will contact you before anything changes.',
  'dom.mailChange.pending': 'Your mail-domain change request is with our team. Nothing changes until they confirm with you.',
  'dom.requests.title': 'Your requests',
  'dom.requests.kind.domain_help': 'Help connecting a domain',
  'dom.requests.kind.mail_domain_change': 'Mail-domain change',
  'dom.requests.status.open': 'Waiting for our team',
  'dom.requests.status.done': 'Done',
  'dom.requests.status.rejected': 'Declined',
  'dom.requests.answer': 'Our answer: {note}',
  'dom.requests.sentOn': 'Sent {date}',
  'apiError.domainTaken': 'This domain is already used by another website.',
  'apiError.domainNotInPackage': 'Your package does not include an own domain.',
  'apiError.domainAtLimit': 'You already have as many domains as your package allows.',
  'apiError.domainElsewhere': 'This domain is linked to another Cloudflare account. Whoever manages it must remove it there first. Ask us for help if you are not sure.',
  'apiError.domainNotRegistered': 'This domain does not seem to be registered. Check the spelling.',
  'apiError.domainInvalid': 'Enter a domain such as yourcompany.com.',
  'apiError.domainSubdomain': 'Enter the main domain (such as yourcompany.com), not a subdomain.',
  'apiError.domainPlatform': 'Addresses under digimasi.com are ours: enter your own domain.',
  'apiError.mailDomainLocked': 'The mail domain cannot be removed. Ask for a change of the mail domain instead.',
  'apiError.primaryDomainLocked': 'Your main address cannot be removed. Contact us if it should change.',
  'apiError.requestOpen': 'You already sent this request. Our team will answer it soon.',
  'apiError.domainsNotIncluded': 'Own domains are not included in your package.',
  'apiError.domainsByDigimasi': 'Own domains for this website are managed by Digimasi. Contact us to add one.',
  'apiError.digimasiUnreachable': 'Digimasi could not be reached. Try again in a minute.',
} as const

export const domainsId: Record<keyof typeof domainsEn, string> = {
  'layout.nav.domains': 'Domain',
  'dom.title': 'Domain',
  'dom.subtitle': 'Pakai domain sendiri untuk website Anda, misalnya perusahaananda.com. Domain tetap di tempat Anda membelinya; Anda cukup mengubah dua pengaturan di sana, sisanya kami yang urus.',
  'dom.count': 'Domain: {used} dari {limit}',
  'dom.countHint': 'Paket Anda mencakup {limit} domain. Alamat utama adalah tempat website Anda; domain lain mengarahkan pengunjung ke sana.',
  'dom.upgrade.title': 'Pakai domain sendiri',
  'dom.upgrade.body': 'Domain sendiri (perusahaananda.com, bukan alamat digimasi.com) tersedia mulai paket Business. Upgrade, lalu kami bantu memasangnya.',
  'dom.empty.title': 'Belum ada domain sendiri',
  'dom.empty.body': 'Website Anda masih di alamat digimasi.com. Tambahkan domain Anda di bawah untuk mulai.',
  'dom.add.title': 'Tambah domain',
  'dom.add.field': 'Domain Anda',
  'dom.add.hint': 'Cukup domainnya, misalnya perusahaananda.com: tanpa www, tanpa https.',
  'dom.add.placeholder': 'perusahaananda.com',
  'dom.add.submit': 'Tambah domain',
  'dom.add.submitting': 'Menambahkan…',
  'dom.added': 'Domain ditambahkan. Sekarang ganti nameserver-nya (lihat langkah di bawah).',
  'dom.atLimit': 'Paket Anda mencakup {limit} domain, dan semuanya sudah terpakai. Hapus domain tambahan, atau upgrade paket Anda.',
  'dom.notConnected': 'Menambah domain belum bisa saat ini. Hubungi kami, nanti kami yang tambahkan.',
  'dom.upgradeCta': 'Upgrade / hubungi kami',
  'dom.chip.primary': 'Alamat utama',
  'dom.chip.mail': 'Domain email',
  'dom.state.waiting': 'Menunggu nameserver',
  'dom.state.connecting': 'Sedang disambungkan',
  'dom.state.active': 'Aktif',
  'dom.state.problem': 'Perlu dicek',
  'dom.added.on': 'Ditambahkan {date}',
  'dom.ns.title': 'Dua nameserver Anda',
  'dom.ns.label': 'Nameserver {n}',
  'dom.steps.title': 'Yang perlu dilakukan',
  'dom.steps.1': 'Masuk ke tempat Anda membeli domain (registrar).',
  'dom.steps.2': 'Cari menu “Nameserver” atau “DNS”, lalu pilih nameserver kustom.',
  'dom.steps.3': 'Ganti nameserver yang ada dengan dua di atas, lalu simpan.',
  'dom.steps.4': 'Tunggu: biasanya beberapa jam, kadang sampai 48 jam. Kami cek otomatis.',
  'dom.check': 'Cek sekarang',
  'dom.checking': 'Mengecek…',
  'dom.checked.waiting': 'Belum: nameserver-nya belum berubah. Kami terus mengecek.',
  'dom.checked.ready': 'Nameserver sudah benar. Berikutnya tim kami menyambungkan domain Anda.',
  'dom.connecting.body': 'Domain Anda sudah siap. Tim kami menyambungkannya ke website Anda, biasanya dalam satu hari kerja. Anda tidak perlu melakukan apa-apa.',
  'dom.active.body': 'Website Anda sudah bisa dibuka di domain ini.',
  'dom.problem.body': 'Ada yang perlu dicek. Tim kami sudah diberi tahu.',
  'dom.primary.note': 'Alamat utama hanya bisa diganti oleh Digimasi.',
  'dom.mail.note': 'Email ke alamat di domain ini masuk ke Inbox Anda. Kalau mau menggantinya, kirim permintaan di bawah.',
  'dom.mail.locked': 'Terkunci',
  'dom.remove': 'Hapus',
  'dom.remove.title': 'Hapus {domain}?',
  'dom.remove.body': 'Website Anda tidak lagi bisa dibuka di {domain}. Kalau domain ini masih menunggu nameserver, pemasangannya dibatalkan. Alamat utama dan email Anda tidak terpengaruh.',
  'dom.remove.confirm': 'Hapus domain',
  'dom.removed': 'Domain dihapus.',
  'dom.help.title': 'Butuh bantuan? Kami sambungkan untuk Anda',
  'dom.help.body': 'Bingung di mana mengganti nameserver? Kabari kami, tim kami bantu atau kerjakan bersama Anda.',
  'dom.help.open': 'Minta bantuan',
  'dom.help.domain': 'Domain yang mana? (opsional)',
  'dom.help.note': 'Ada yang perlu kami tahu? (opsional)',
  'dom.help.notePlaceholder': 'Misalnya: tempat Anda membeli domain, atau waktu yang pas untuk kami telepon.',
  'dom.help.submit': 'Kirim permintaan',
  'dom.help.sent': 'Permintaan terkirim. Tim kami akan menghubungi Anda.',
  'dom.help.pending': 'Permintaan bantuan Anda sedang ditangani tim kami. Kami akan menghubungi Anda.',
  'dom.mailChange.title': 'Minta ganti domain email',
  'dom.mailChange.body': 'Domain email Anda {domain}. Tim kami bisa memindahkan mailbox Anda ke domain Anda yang lain.',
  'dom.mailChange.open': 'Minta penggantian',
  'dom.mailChange.domain': 'Domain email baru (opsional)',
  'dom.mailChange.domainOther': 'Domain lain',
  'dom.mailChange.domainFree': 'Domain yang Anda inginkan',
  'dom.mailChange.note': 'Alasannya, atau apa yang perlu diganti',
  'dom.mailChange.warning': 'Alamat di domain lama tidak akan menerima email lagi dan aksesnya hilang. Riwayat emailnya akan dihapus. Ini tidak bisa dibatalkan.',
  'dom.mailChange.ack': 'Saya mengerti',
  'dom.mailChange.submit': 'Kirim permintaan',
  'dom.mailChange.sent': 'Permintaan terkirim. Tim kami akan menghubungi Anda sebelum ada yang berubah.',
  'dom.mailChange.pending': 'Permintaan ganti domain email Anda sedang ditangani tim kami. Tidak ada yang berubah sebelum mereka konfirmasi dengan Anda.',
  'dom.requests.title': 'Permintaan Anda',
  'dom.requests.kind.domain_help': 'Bantuan menyambungkan domain',
  'dom.requests.kind.mail_domain_change': 'Ganti domain email',
  'dom.requests.status.open': 'Menunggu tim kami',
  'dom.requests.status.done': 'Selesai',
  'dom.requests.status.rejected': 'Ditolak',
  'dom.requests.answer': 'Jawaban kami: {note}',
  'dom.requests.sentOn': 'Dikirim {date}',
  'apiError.domainTaken': 'Domain ini sudah dipakai website lain.',
  'apiError.domainNotInPackage': 'Paket Anda belum mencakup domain sendiri.',
  'apiError.domainAtLimit': 'Jumlah domain Anda sudah sesuai batas paket.',
  'apiError.domainElsewhere': 'Domain ini terhubung ke akun Cloudflare lain. Pengelolanya harus menghapusnya dari sana dulu. Minta bantuan kami kalau ragu.',
  'apiError.domainNotRegistered': 'Domain ini sepertinya belum terdaftar. Cek lagi ejaannya.',
  'apiError.domainInvalid': 'Masukkan domain, misalnya perusahaananda.com.',
  'apiError.domainSubdomain': 'Masukkan domain utama (misalnya perusahaananda.com), bukan subdomain.',
  'apiError.domainPlatform': 'Alamat di bawah digimasi.com milik kami: masukkan domain Anda sendiri.',
  'apiError.mailDomainLocked': 'Domain email tidak bisa dihapus. Kirim permintaan ganti domain email saja.',
  'apiError.primaryDomainLocked': 'Alamat utama tidak bisa dihapus. Hubungi kami kalau perlu diganti.',
  'apiError.requestOpen': 'Permintaan ini sudah Anda kirim. Tim kami akan segera menjawabnya.',
  'apiError.domainsNotIncluded': 'Paket Anda belum mencakup domain sendiri.',
  'apiError.domainsByDigimasi': 'Domain sendiri untuk website ini dikelola oleh Digimasi. Hubungi kami untuk menambahkannya.',
  'apiError.digimasiUnreachable': 'Digimasi tidak bisa dihubungi. Coba lagi sebentar lagi.',
}

/** The domain API's fixed English messages (from the console, through the site's API), by exact text. */
export const DOMAIN_SERVER_MESSAGE_KEYS: Record<string, keyof typeof domainsEn> = {
  'This domain is already used by a site': 'apiError.domainTaken',
  'This site’s package does not include an own domain': 'apiError.domainNotInPackage',
  'This site already has as many domains as its package allows': 'apiError.domainAtLimit',
  'This domain is already on another Cloudflare account. Whoever controls that account must remove it there before we can add it.': 'apiError.domainElsewhere',
  'Cloudflare says this is not a registered domain': 'apiError.domainNotRegistered',
  'Enter a domain such as example.com': 'apiError.domainInvalid',
  'Enter the main domain (such as example.com), not a subdomain': 'apiError.domainSubdomain',
  'Addresses under digimasi.com are ours: enter the client’s own domain': 'apiError.domainPlatform',
  'The mail domain cannot be removed. Ask for a change of the mail domain instead.': 'apiError.mailDomainLocked',
  'The primary domain cannot be removed. Make another connected domain primary first.': 'apiError.primaryDomainLocked',
  'You already sent this request. Our team will answer it soon.': 'apiError.requestOpen',
  'Own domains are not included in this package': 'apiError.domainsNotIncluded',
  'Own domains are managed by Digimasi for this site. Contact us to add one.': 'apiError.domainsByDigimasi',
  'Digimasi could not be reached. Try again in a minute.': 'apiError.digimasiUnreachable',
  'Digimasi sent an unexpected answer': 'apiError.digimasiUnreachable',
}
